import axiosInstance from "../config/axios.config";

export const getIpWhitelistingConfigsApi = () => {
  return axiosInstance.get(`accounts/ip-whitelisting/config/`);
};

export const upsertIpWhitelistingConfigApi = (payload) => {
  // payload: { facility_id, enabled, mode }
  return axiosInstance.patch(`accounts/ip-whitelisting/config/`, payload);
};

export const getIpWhitelistingFacilityIpsApi = (facilityId) => {
  return axiosInstance.get(
    `accounts/ip-whitelisting/facilities/${facilityId}/ips/`
  );
};

export const addIpWhitelistingFacilityIpApi = (facilityId, payload) => {
  // payload: { organization, facility, label, value }
  return axiosInstance.post(
    `accounts/ip-whitelisting/facilities/${facilityId}/ips/`,
    payload
  );
};

export const updateIpWhitelistingFacilityIpApi = (ipId, payload) => {
  return axiosInstance.patch(`accounts/ip-whitelisting/ips/${ipId}/`, payload);
};

export const deleteIpWhitelistingFacilityIpApi = (ipId) => {
  return axiosInstance.delete(`accounts/ip-whitelisting/ips/${ipId}/`);
};

export const getIpWhitelistingBypassUsersApi = () => {
  return axiosInstance.get(`accounts/ip-whitelisting/bypass/`);
};

export const createIpWhitelistingBypassUserApi = (payload) => {
  // payload: { user_id, facility_id, is_active }
  return axiosInstance.post(`accounts/ip-whitelisting/bypass/`, payload);
};

export const updateIpWhitelistingBypassUserApi = (id, payload) => {
  // payload: { facility, user, is_active }
  return axiosInstance.patch(
    `accounts/ip-whitelisting/bypass/${id}/`,
    payload
  );
};

export const deleteIpWhitelistingBypassUserApi = (id) => {
  return axiosInstance.delete(`accounts/ip-whitelisting/bypass/${id}/`);
};

export const getIpWhitelistingAccessLogsApi = (params = "") => {
  return axiosInstance.get(`accounts/ip-whitelisting/access-logs/?${params}`);
};

